import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'

import { LicenseInfo } from '@mui/x-license'
import * as React from 'react'
import { createRoot } from 'react-dom/client'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { PageHistoryManager } from 'src/3rds/cube-react'

import { MuiTheme } from './theme'
import { MainPresenter } from './main'
import { buildCube } from './Cube'
import { LocaleProvider } from 'src/utils/views/locale'

import { registerViews as registerWaitingViews } from './components/waiting/views'
import { registerViews as registerMainViews, MainView } from './main/views'
import { registerViews as registerOverviewViews } from './modules/overview/views'
import { registerViews as registerRestrictedViews } from './modules/restricted/views'
import { registerViews as registerUserProfileViews } from './modules/user-profile/views'
import { registerViews as registerCadastroLoteViews } from './modules/cadastro-lote/views'
import { registerViews as registerCampanhaViews } from './modules/campanha/views'
import { registerViews as registerGrupoManualViews } from './modules/grupo-manual/views'
import { registerViews as registerDashboardsViews } from './modules/dashboards/views'
import { registerViews as registerBloqueiosViews } from './modules/bloqueios/views'
import { registerViews as registerTemplatesViews } from './modules/templates/views'
import { registerViews as registerMensagemDiretaViews } from './modules/mensagem-direta/views'
import { moduloSimulador } from './simulador'

LicenseInfo.setLicenseKey(
    'e6e2a927329dbfd9e981659d8bcd9994Tz05NDUzNSxFPTE3NTI5NDkwMDcwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI='
)

registerWaitingViews()
registerMainViews()
registerOverviewViews()
registerRestrictedViews()
registerUserProfileViews()
registerCadastroLoteViews()
registerCampanhaViews()
registerGrupoManualViews()
registerDashboardsViews()
registerBloqueiosViews()
registerTemplatesViews()
registerMensagemDiretaViews()
// Telas da conversa do WhatsApp: só existem quando o simulador está no pacote (E13).
moduloSimulador?.registerViews()

buildCube()

const historyManager = new PageHistoryManager(true)

function App() {
    const presenter = React.useMemo(() => new MainPresenter(historyManager), [])

    React.useEffect(() => {
        const handleOnComponentWillUnmount = presenter.initialize()
        return () => {
            handleOnComponentWillUnmount()
        }
    }, [presenter])

    const locale = LocaleProvider.get()

    return (
        <MuiTheme>
            <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale="pt-br"
                localeText={locale.mui.components.MuiLocalizationProvider.defaultProps.localeText}
            >
                <MainView scope={presenter.scope} />
            </LocalizationProvider>
        </MuiTheme>
    )
}

const container = document.getElementById('root')
if (container) {
    const root = createRoot(container)
    root.render(<App />)
}
